// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"424":"cc4d075f","827":"8ccc6c9b","945":"d1883ee5"}[chunkId] + ".css";
};